import Raven from 'raven-js'

// @see https://docs.getsentry.com/hosted/clients/javascript/usage/#raven-js-reporting-errors

export function track(err, options) {
  // don't let raven cause more exceptions...
  try {
    console.error(err)
    Raven.captureException(err, options)
  } catch (e) {
    console.error(e)
  }
}



// WEBPACK FOOTER //
// ./lib/utils/errors.js